{
  "EMOJI": {
    "PLACEHOLDER": "Meklēt emocijzīmes",
    "NOT_FOUND": "Neviena emocijzīme neatbilst jūsu meklēšanas vaicājumam",
    "REMOVE": "Noņemt"
  }
}
